import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { socket } from '../services/socket';
import '../styles/LobbyScreen.css';

function LobbyScreen({ playerName, setPlayerName, setPlayerId }) {
    const [rooms, setRooms] = useState([]);
    const [newRoomName, setNewRoomName] = useState('');
    const [isConnected, setIsConnected] = useState(socket.connected);
    const navigate = useNavigate();

    useEffect(() => {
        // Connect to the socket server
        socket.connect();

        // Set up event listeners
        socket.on('connect', () => {
            setIsConnected(true);
            setPlayerId(socket.id);
            socket.emit('getRooms');
        });

        socket.on('disconnect', () => {
            setIsConnected(false);
        });

        socket.on('roomsList', (roomsList) => {
            setRooms(roomsList);
        });

        socket.on('joinedRoom', (roomId) => {
            navigate(`/game/${roomId}`);
        });

        // Clean up event listeners
        return () => {
            socket.off('connect');
            socket.off('disconnect');
            socket.off('roomsList');
            socket.off('joinedRoom');
        };
    }, [navigate, setPlayerId]);

    const createRoom = () => {
        if (!playerName || !newRoomName) return;

        socket.emit('createRoom', {
            name: newRoomName,
            creator: playerName,
            maxPlayers: 10
        });
    };

    const joinRoom = (roomId) => {
        if (!playerName) return;

        socket.emit('joinRoom', {
            roomId,
            playerName
        });
    };

    return (
        <div className="lobby-screen">
            <div className="connection-status">
                Status: {isConnected ? 'Connected' : 'Disconnected'}
            </div>

            <div className="player-setup">
                <h2>Enter Your Name</h2>
                <input
                    type="text"
                    value={playerName}
                    onChange={(e) => setPlayerName(e.target.value)}
                    placeholder="Your name"
                    maxLength={15}
                />
            </div>

            <div className="create-room">
                <h2>Create New Room</h2>
                <div className="room-form">
                    <input
                        type="text"
                        value={newRoomName}
                        onChange={(e) => setNewRoomName(e.target.value)}
                        placeholder="Room name"
                        disabled={!playerName}
                    />
                    <button
                        onClick={createRoom}
                        disabled={!playerName || !newRoomName}
                    >
                        Create Room
                    </button>
                </div>
            </div>

            <div className="available-rooms">
                <h2>Available Rooms</h2>
                {rooms.length === 0 ? (
                    <p>No rooms available. Create one!</p>
                ) : (
                    <ul className="rooms-list">
                        {rooms.map((room) => (
                            <li key={room.id} className="room-item">
                                <div className="room-info">
                                    <span className="room-name">{room.name}</span>
                                    <span className="room-players">
                    {room.players}/{room.maxPlayers} players
                  </span>
                                </div>
                                <button
                                    onClick={() => joinRoom(room.id)}
                                    disabled={!playerName || room.players >= room.maxPlayers}
                                >
                                    Join
                                </button>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
}

export default LobbyScreen;
